class Header {
	constructor(config) {
		this.config = Object.assign({
			scope: 'header',
			langSwitch: '.language-toggle',
			searchToggle: '.search-toggle',
			searchToggleMobile: '.search-toggle-mobile',
			searchToggle2: '.search-form .icon-close-2',
			searchCloseMobile: '.close-search-mobile',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.hamburgerToggle();
		this.eventListeners();
	}

	eventListeners() {
		this.$scope.on('click', this.config.langSwitch, this.toggleLanguageDropdown.bind(this));
		this.$scope.on('click', this.config.searchToggle, this.toggleSearchDropdown.bind(this));
		this.$scope.on('click', this.config.searchToggle2, this.toggleSearchDropdown.bind(this));
		this.$scope.on('click', this.config.searchToggleMobile, this.toggleSearchDropdownMobile.bind(this));
		this.$scope.on('click', this.config.searchCloseMobile, this.toggleSearchDropdownMobile.bind(this));
		this.$scope.on('click', this.config.searchCloseMobile, this.toggleSearchMobile.bind(this));
	}

	scrollTop() {
		const page = document.querySelector("html");
		return page.scrollTop;
	}

	toggleLanguageDropdown(event) {
		let $target = $(event.currentTarget);
		let $parent = $target.closest('.language-switcher');
		let $dropdown = $parent.find('.dropdown-menu');
		$dropdown.toggleClass('d-block');
	}

	hamburgerToggle() {
		$(".hamburger").on("click", function (e) {
			$(e.currentTarget).toggleClass("is-active");
			this.dropdownToggle();
		}.bind(this));
	}

	dropdownToggle() {
		let $windowHeight = $(window).height();
		let $body = $('body');
		let $pageHeight = $body.height();
		$('html').toggleClass('dropdown-open');
		$('.search-form').addClass('d-none');
		$body.toggleClass('dropdown-open');
		if (!$('.dropdown-main').hasClass('d-none')) {
			$('.header-backdrop').toggleClass('d-none');
		}
		if ($windowHeight >= $pageHeight) {
			$body.toggleClass('pr-0');
		}
	}

	toggleSearchDropdown(event) {
		if($('.dropdown-main').is('.show') && $(window).width() >= 992) {
			$('[data-toggle="collapse"]').click();
			$('.header-backdrop').addClass('d-none');
		}
		$('.search-form').toggleClass('d-none');
		$('.search-form input[name=q]').focus();
	}

	toggleSearchDropdownMobile(event) {
		let $search = $('.search-form');
		$('.search-toggle-mobile').toggleClass('d-none');
		$search.toggleClass('d-none');
		$search.toggleClass('d-flex');
		$('.login-text').toggleClass('d-none');
		$('.lang-text').toggleClass('d-none');
	}

	toggleSearchMobile(event) {
		$('.search-toggle-mobile').removeClass('d-none');
		$('.search-form').addClass('d-none');
	}
}

export default new Header